var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJobType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F1FBFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3078 12.0833C17.0811 12.1644 16.8588 12.2545 16.6415 12.3533M14.5209 13.7214C14.3321 13.8869 14.1509 14.0605 13.9778 14.2415M12.5265 16.304C12.3717 16.615 12.236 16.9369 12.1208 17.2679M11.6801 19.4928C11.6616 19.8173 11.6623 20.1482 11.682 20.4728M12.1404 22.7215C12.2512 23.033 12.3804 23.3363 12.5265 23.6298M13.9091 25.6196C14.1126 25.8375 14.3277 26.0449 14.5535 26.2409M16.4803 27.5053C16.809 27.6628 17.1494 27.8005 17.5 27.9167",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 28.3333C24.6023 28.3333 28.3333 24.6023 28.3333 20C28.3333 15.3976 24.6023 11.6667 20 11.6667",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 21.25C20.6903 21.25 21.25 20.6903 21.25 20C21.25 19.3097 20.6903 18.75 20 18.75M20 21.25C19.3097 21.25 18.75 20.6903 18.75 20C18.75 19.3097 19.3097 18.75 20 18.75M20 21.25V23.3333M20 18.75V15",
    stroke: "#003E3E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobType);
export default __webpack_public_path__ + "static/media/Job_type.1802446e7865ca313a209e813a41f5bb.svg";
export { ForwardRef as ReactComponent };